import {
  AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
  TemplateRef, ViewChild
} from '@angular/core';
import { CustomTableComponent } from '../../../../shared/ui/custom-table/components/table/custom-table.component';
import { TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';
import { Utils } from '../../../../shared/utils';
import { Model182, Model182Declarado, Model182Validation } from '../taxes-182.model';

export interface Model182DeclaradoFila extends Model182Declarado {
  indice: number;
  errores: number;
}

@Component({
  selector: 'app-model-182-declarados',
  templateUrl: './model-182-declarados.component.html',
  styleUrls: ['./model-182-declarados.component.css'],
  standalone: false
})
export class Model182DeclaradosComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() data: Model182;
  @Input() validaciones: Model182Validation[] = [];

  @Output() nuevo = new EventEmitter<void>();
  @Output() editar = new EventEmitter<number>();
  @Output() eliminar = new EventEmitter<number>();
  @Output() origen = new EventEmitter<number>();

  @ViewChild('table', { static: false }) t1!: CustomTableComponent;
  @ViewChild('importeTpl', { static: true }) importeTpl!: TemplateRef<any>;
  @ViewChild('origenTpl', { static: true }) origenTpl!: TemplateRef<any>;
  @ViewChild('estadoTpl', { static: true }) estadoTpl!: TemplateRef<any>;

  tableConfig!: TableConfig;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const porcentaje = (valor: any) => valor === null || valor === undefined || valor === '' ? '-' : valor + ' %';

    this.tableConfig = {
      columns: [
        { key: 'errores', label: 'Estado', sortable: false, customTemplate: this.estadoTpl, width: '110px' },
        { key: 'origen', label: 'Origen', sortable: false, customTemplate: this.origenTpl, width: '120px' },
        { key: 'nif', label: 'NIF', sortable: false, width: '120px' },
        {
          key: 'nombre', label: 'Nombre o razón social', sortable: false,
          onCellClick: (row: Model182DeclaradoFila) => this.editar.emit(row.indice)
        },
        { key: 'clave', label: 'Clave', sortable: false, width: '80px' },
        { key: 'porcentajeDeduccion', label: '% deducción', sortable: false, formatFn: porcentaje, width: '110px' },
        { key: 'importe', label: 'Importe', sortable: false, customTemplate: this.importeTpl },
        { key: 'recurrencia', label: 'Recurrencia', sortable: false, formatFn: (valor: any) => valor || '-', width: '110px' }
      ],
      actions: [
        { label: 'Editar', icon: 'edit', callback: (row: Model182DeclaradoFila) => this.editar.emit(row.indice) },
        { label: 'Eliminar', icon: 'delete', callback: (row: Model182DeclaradoFila) => this.eliminar.emit(row.indice) }
      ],
      headerActions: [
        { label: 'Nuevo declarado', icon: 'add', type: 'button', callback: () => this.nuevo.emit() }
      ],
      filterView: 'model182Declarados',
      defaultFilter: {},
      selectable: false,
      pagination: false,
      noDataText: 'No hay declarados en este ejercicio'
    };
  }

  ngAfterViewInit(): void {
    this.pintar();
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.t1 && (changes['data'] || changes['validaciones'])) {
      this.pintar();
    }
  }

  formatoImporte(valor: any): string {
    return Utils.FormatMoney(valor) + ' €';
  }

  private pintar(): void {
    if (!this.t1) return;

    const filas: Model182DeclaradoFila[] = (this.data?.declarados || []).map((item, indice) => ({
      ...item,
      indice,
      errores: this.validaciones.filter(v => (v.key || '').startsWith(`declarados[${indice}].`) && v.type !== 'WARNING').length
    }));

    this.t1.tableState.setData(filas);
    this.t1.tableState.setTotalItems(filas.length);
  }
}
